import { useCallback, useState } from "react";

import UnifiedTagModal from "@/features/player-kanban/components/organisms/UnifiedTagModal";

/**
 * Props for useTagManagement hook
 */
interface UseTagManagementProps {
  /** Board ID for fetching board-specific tag colors */
  boardId?: string;
}

/**
 * Custom hook for managing tag modal state for TopPanel
 * Uses the unified tag modal that combines selection and management
 * @param props - Hook props
 * @param props.boardId - Board ID for fetching board-specific tag colors
 * @returns Object containing tag management handler and modal component
 */
const useTagManagement = ({ boardId }: UseTagManagementProps) => {
  const [showTagManager, setShowTagManager] = useState(false);

  const handleManageTags = useCallback(() => {
    setShowTagManager(true);
  }, []);

  const handleCloseTagManager = useCallback(() => {
    setShowTagManager(false);
  }, []);

  return {
    // Handler
    handleManageTags,

    // Unified tag modal component - opens in manage mode without player context
    tagManagerComponent: (
      <UnifiedTagModal
        isOpen={showTagManager}
        mode="manage"
        boardId={boardId}
        onClose={handleCloseTagManager}
      />
    ),
  };
};

export default useTagManagement;
